import React, { useState, useEffect } from 'react';
import axios from "axios";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Container,
} from "reactstrap";

import {
  Modal,
  Fade,
  Backdrop
} from "@material-ui/core";

// Charts
import LineChart from '../../variables/LineChart';

// Date Range Picker
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { ko } from 'date-fns/locale'

import { addDays } from 'date-fns';

import { useTranslation } from 'react-i18next';

// Loader
import Loader from "react-spinner-loader";

let dataType = "";

export default function LSIM_IE(props) {
    const { t, i18n } = useTranslation();

  // Chart
  const [modalIsOpen, setIsOpen] = React.useState(false); //MODAL

  const [errors, setErrors] = React.useState([]);
  const [linechartData, setLineChartData] = React.useState(); // Chart data

  const [calendarPick, setcalendarPick] = useState([ //달력 picker
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: 'selection'
    }
  ]);

  const [isLoading, setIsLoading] = useState(false);//로딩바
  // 새로고침 관련 상태
  const [isRefreshing, setIsRefreshing] = useState(false);

  const ChartType_line = "line";
  const [xMax, setXMax] = useState(Number.MAX_VALUE);
  const [yMax, setYMax] = useState(Number.MIN_VALUE);

  function openModal(ChartType) {
    //alert(ChartType);
    dataType = ChartType;
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  async function dateQuery(startDate, endDate, chartType) {
    //UTC+9에서 UTC+0변환
    //const formattedDate = utcDate.slice(0, 4) + utcDate.slice(5, 7) + utcDate.slice(8, 10);
    //const formattedDate = date.toLocaleDateString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\./g, '');
    setIsLoading(true);
    const dateDifference = (endDate - startDate) / (1000 * 60 * 60 * 24);

    // if (dateDifference >= 1 && (props.roleCheck != "admin")) {
    if (props.roleCheck != "admin"){
      alert("권한이 필요합니다. 서비스 문의를 이용해주세요");
      setIsLoading(false);
      return;
    }
    // If the difference exceeds 1 month, show an alert and return early
    if (dateDifference > 30) {
      alert("최대 1달까지 조회가 가능합니다.");
      setIsLoading(false);
      return;
    }

    //alert("dataQuery: " + startDate + '/' + endDate +  '/' + chartType);
    //시작일~ 종료일 YYYY-MM-DD 포맷 변경
    startDate = startDate.toLocaleDateString().replace(/\./g, '').split(' ').map((v, i) => i > 0 && v.length < 2 ? '0' + v : v).join('-');
    endDate = endDate.toLocaleDateString().replace(/\./g, '').split(' ').map((v, i) => i > 0 && v.length < 2 ? '0' + v : v).join('-');

    //alert(startDate+","+endDate+","+chartType);
    //console.log(startDate + '/' + endDate + '/' + chartType);

    let LSIMquery;
    try {

      LSIMquery = await axios.post(
        `/con_lsim`,
        {
          startDate: startDate,
          endDate: endDate,
          chartType: chartType,
        },
        { baseURL: process.env.REACT_APP_SERVER_URL },
        { withCredentials: true },
      );
    } catch ({ response }) {
      LSIMquery = response;
      alert(JSON.stringify(response));
    }

    const { data: LSIMqueryData } = LSIMquery;
    if (!LSIMqueryData || (Array.isArray(LSIMqueryData) && LSIMqueryData.length === 0)) {
      alert("Alert limit을 초과한 데이터가 존재하지 않습니다");
      setIsLoading(false);
      return;
    }

    if (LSIMqueryData.success) {
      //alert("access fail\n"+JSON.stringify(LSIMqueryData));
      setErrors(
        LSIMqueryData.messages && LSIMqueryData.messages.errors
      );
    } else {
      const newChartData_Line = Object.values(LSIMqueryData).map(e => {
        let extractHours = e.x.slice(-2);
        return { x: extractHours, y: e.count };
      });
      //setChartData(newChartData); 
      let max = 0;
      for (let i = 0; i < newChartData_Line.length; i++) {
        if (newChartData_Line[i].y > max) {
          max = newChartData_Line[i].y;
        }
      }
      //alert(JSON.stringify(newChartData_Line));
      //console.log(JSON.stringify(newChartData_Line));

      setLineChartData(newChartData_Line);

      let xMax = Number.MIN_VALUE;
      let yMax = Number.MIN_VALUE;
      newChartData_Line.forEach(data => {
        if (Number(data.x) > xMax) {
          xMax = data.x;
        }
        if (Number(data.y) > yMax) {
          yMax = Number(data.y);
        }
      });

      // Pass the minimum and maximum values of the x and y axis as props to the LineChart component
      setXMax(xMax);
      setYMax(yMax);
    }
  }
  useEffect(() => {
    // This function will be called after the state update is completed.
    setIsLoading(false);
  }, [linechartData]);
  const handleRefreshClick = () => {
      if (isRefreshing) {
          // 새로고침 중지
          setIsRefreshing(false);
      } else {
          // 새로고침 시작
          setIsRefreshing(true);
          // "오늘" 버튼과 동일한 기능을 수행
          dateQuery(new Date(), new Date(), ChartType_line);
      }
  };
  // 새로고침 상태 변경에 따른 타이머 설정 및 해제
  useEffect(() => {
      let interval;
      if (isRefreshing) {
          interval = setInterval(() => {
              dateQuery(new Date(), new Date(), ChartType_line);
          }, 60000); // 1분마다 실행
      }
      return () => clearInterval(interval); // 컴포넌트가 언마운트되거나 새로고침이 중지될 때 타이머 해제
  }, [isRefreshing]);

  return (
    <div className="GraphContent">
      <div className="SearchContent">
        <div className="SearchArea">
          <span className="searchText">{t('LoneSmart.Monitoring.QueryPeriod')} :</span>
          <Button
            className={`selectBtn ${i18n.language && i18n.language.startsWith('en') ? 'selectBtn-en' : ''}`}
            onClick={() => {
              dateQuery(new Date(), new Date(), ChartType_line)
            }}>
            {t('LoneSmart.Monitoring.Today')}
          </Button>
          <Button
            className={`selectBtn ${i18n.language && i18n.language.startsWith('en') ? 'selectBtn-en' : ''}`}
            onClick={() => {
              const endDate = new Date();
              const startDate = new Date();
              startDate.setDate(endDate.getDate() - 7);
              dateQuery(startDate, endDate, ChartType_line);
            }}
          >
            {t('LoneSmart.Monitoring.LastWeek')}
          </Button>
          <Button id="lineRange"
            className={`selectBtn ${i18n.language && i18n.language.startsWith('en') ? 'selectBtn-en' : ''}`}
            onClick={() => openModal(ChartType_line)}>
            {t('LoneSmart.Monitoring.DateQuery')}
          </Button>
          {props.roleCheck === "admin" && (
              <Button
                  className={`selectBtn ${i18n.language && i18n.language.startsWith('en') ? 'selectBtn-en' : ''}`}
                  onClick={handleRefreshClick}
              >
                  {isRefreshing ? t('LoneSmart.Monitoring.StopRefresh') : t('LoneSmart.Monitoring.StartRefresh')}
              </Button>
          )}
        </div>
      </div>
      <div className="searchExampleText">{t('LoneSmart.Monitoring.SelectPeriodMessage')}</div>
      {/* </div> */}
      <div className="GraphArea" style={{ width: '45%', height: '45%' }}>
        {isLoading &&
          // 로딩 중일 때 로딩 스피너 또는 메시지 표시
          <div className="loader">
            <div className="loader-container">
              <p className='loader-title'>Loading...</p>
            </div>
          </div>
        }
        <div style={{ margin: 'auto', position: 'relative', width: '100%', height: '100%', textAlign: 'center' }}>
          <LineChart linechartData={linechartData} xMax={xMax} yMax={yMax} />
        </div>
        <Modal
          open={modalIsOpen}
          onClose={closeModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} // 중앙 위치로 변경
        >
          <Fade in={modalIsOpen}>
          <div  // <-- Use a div here
              style={{ width: 'fit-content' }}
            >
              <Container
                style={{
                  width: 'fit-content',
                  display: 'flex',
                  flexDirection: 'column',
                  // alignItems: 'center',
                  // justifyContent: 'center',
                  margin: 'auto',
                }}
             
              >
              <Card>
                <CardHeader>Calendar</CardHeader>
                <CardBody>
                  <DateRangePicker
                    locale={ko}
                    onChange={item => setcalendarPick([item.selection])}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    months={2}
                    ranges={calendarPick}
                    direction="horizontal"
                    maxDate={addDays(new Date(), 0)}
                  />
                  <CardFooter>
                  <Button className="modalBtn itsBtnDefault" onClick={() => { setIsOpen(false); dateQuery(calendarPick[0].startDate, calendarPick[0].endDate, dataType) }}>
                      조회
                    </Button>
                    <Button className="modalBtn itsBtnGray" onClick={closeModal}>
                      닫기
                    </Button>
                  </CardFooter>
                </CardBody>
              </Card>
            </Container>
            </div>
          </Fade>
        </Modal>
      </div>
    </div>
  )
};